export default "__VITE_ASSET__CSOsGRmS__"